// extracted by mini-css-extract-plugin
export default {"loyaltyCoefficient":"src-components-LoyaltyCoefficient--loyaltyCoefficient","loyaltyCoefficient_withText":"src-components-LoyaltyCoefficient--loyaltyCoefficient_withText"};